import { render } from "./FinanzierungMitLandBetragsrechnerBelegVergleich.pug?vue&type=template&id=5f8e38c0&lang=pug"
import script from "./FinanzierungMitLandBetragsrechnerBelegVergleich.js?vue&type=script&lang=js"
export * from "./FinanzierungMitLandBetragsrechnerBelegVergleich.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__